
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'billing-portal-ui',
  currentProjectVersion: 'static-1.1048',
  depVersions: {
  "billing-portal-ui": "static-1.1048",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.455",
  "head-dlb": "static-1.4921",
  "hs-test-utils": "static-1.7903",
  "hub-http-shared-msw-handlers": "static-1.9709",
  "hubspot-dlb": "static-2.1828",
  "react-dlb": "static-1.76",
  "billing-portal-service-types": "static-1.886",
  "data-fetching-client": "static-1.9567",
  "foundations-assets": "static-1.4738",
  "foundations-components": "static-1.7703",
  "foundations-theming": "static-1.4304",
  "framework-data-table": "static-2.11647",
  "hub-http": "static-1.6110",
  "HubStyleTokens": "static-2.11342",
  "I18n": "static-7.1598",
  "metrics-js": "static-1.9522",
  "PortalIdParser": "static-2.386",
  "portals-platform-lib": "static-1.688",
  "quartz-config": "static-1.634",
  "quartz-core": "static-1.6075",
  "quick-fetch": "static-1.3826",
  "raven": "static-3.5808",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16546",
  "react-router-dom": "static-5.26",
  "redux": "static-4.16",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4535",
  "styled-components": "static-2.87",
  "ui-addon-iframeable": "static-1.8941",
  "ui-addon-react-router-dom": "static-1.9436",
  "UIComponents": "static-3.8289",
  "usage-tracker": "static-1.7228",
  "usage-tracker-anonymous": "static-1.5645",
  "usage-tracker-core": "static-1.7078",
  "customer-data-objects": "static-1.7547",
  "customer-data-properties": "static-1.51141",
  "customer-data-property-utils": "static-1.7975",
  "sanitize-text": "static-1.8036",
  "meetings-icalendar-utils-lib": "static-1.522",
  "property-translator": "static-1.5301",
  "smart-property-lib": "static-1.6389",
  "commerce-products-lib": "static-1.9120",
  "ui-addon-i18n": "static-1.11039",
  "ui-addon-form-validation": "static-1.10883",
  "object-builder-ui-client": "static-1.48351",
  "ui-addon-upgrades": "static-9.17825",
  "purchase-motions-components": "static-1.5665",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.425",
  "hs-promise-rejection-tracking": "static-1.5473",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4034",
  "immutable": "static-2.76",
  "bend-plugin-trellis-migration": "static-1.3317",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3133",
  "quartz-webpack": "static-1.3080",
  "HeadJS": "static-2.732",
  "quartz": "static-1.6856",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3014",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.3989",
  "webpack-env": "static-1.54",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "bend-plugin-foundations-components": "static-1.3972",
  "floating-ui": "static-1.54",
  "foundations-theming-specialty": "static-1.2020",
  "hs-story-utils": "static-1.9321",
  "react-aria": "static-1.64",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5259",
  "react-virtualized": "static-2.97",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1502",
  "ui-fonts": "static-1.604",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-theming": "static-1.2787",
  "foundations-theming-base": "static-1.3289",
  "stylex": "static-1.30",
  "ai-components-ui-library": "static-1.8646",
  "crm-pipelines-api-client-types": "static-1.4053",
  "atom": "static-1.4962",
  "avatar-components": "static-1.2385",
  "crm-links": "static-1.6167",
  "cssUtils": "static-1.764",
  "customer-data-associations": "static-1.7215",
  "customer-data-objects-ui-components": "static-1.12910",
  "customer-data-reference-ui-components": "static-1.13045",
  "customer-data-ui-utilities": "static-1.9717",
  "deal-intel-decorators": "static-1.1602",
  "framework-data-schema-resolvers": "static-1.6767",
  "frontend-preferences-client": "static-1.7816",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5486",
  "hubspot-apollo-client": "static-1.4770",
  "HubStyle": "static-2.11650",
  "icons": "static-2.637",
  "immer": "static-1.33",
  "PatternValidationJS": "static-1.437",
  "property-value-citations": "static-1.1755",
  "quartz-i18n": "static-1.531",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8058",
  "reference-resolvers-lite": "static-1.7981",
  "reporting-data": "static-1.66969",
  "sanitize": "static-1.4364",
  "SharedI18nStrings": "static-1.181",
  "tanstack-virtual": "static-1.28",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4661",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.81",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5642",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4563",
  "jasmine": "static-4.4216",
  "jasmine-runner": "static-1.6361",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.531",
  "quartz-head": "static-1.521",
  "quartz-routing": "static-1.286",
  "quartz-test": "static-1.531",
  "quartz-tracking": "static-1.235",
  "usage-tracker-container": "static-1.7218",
  "csstype": "static-1.50",
  "history": "static-4.47",
  "chirp-fetch": "static-1.1773",
  "magpie-lib": "static-1.5485",
  "navigation-messaging": "static-1.6942",
  "inbound-db-properties-service-client": "static-1.3757",
  "autolinker": "static-3.11",
  "calling-global-api": "static-1.64063",
  "calling-internal-common": "static-1.31193",
  "calling-lifecycle-internal": "static-1.65445",
  "calling-lifecycle-messages": "static-1.57739",
  "conditional-properties-service-client": "static-1.3708",
  "crm-message-bus": "static-1.42658",
  "external-options-client-types": "static-1.4069",
  "file-manager-components": "static-1.23258",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.29",
  "inbound-db-meta-service-client": "static-1.3500",
  "inbounddb-objects-service-types": "static-1.4134",
  "multi-currency-client-types": "static-1.3600",
  "pipeline-validation-client-types": "static-1.3876",
  "pulse": "static-1.428",
  "tiered-pricing": "static-1.996",
  "user-context": "static-1.4991",
  "data-agent-kit": "static-1.19",
  "data-token-picker": "static-1.16214",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9792",
  "fsm": "static-1.3625",
  "policy-lib": "static-1.6674",
  "react-colorpicker": "static-2.10101",
  "react-tinymce": "static-1.54910",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9855",
  "rich-text-lib": "static-1.19643",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54036",
  "tinymce-plugins": "static-1.57150",
  "tinymce-themes": "static-1.56006",
  "commerce-permissions": "static-1.657",
  "customer-data-tracking": "static-1.6775",
  "growth-payments-core": "static-1.25018",
  "products-iframe-lib": "static-1.7608",
  "products-ui-components-shared-msw-handlers": "static-1.10091",
  "foundations-components-test-utils": "static-1.5186",
  "laboratory-lib": "static-3.7051",
  "merchandise-lib": "static-1.261",
  "salesImages": "static-1.522",
  "foundations-components-legacy": "static-1.728",
  "growth-monetization-service-types": "static-1.4393",
  "nav-client-types": "static-1.2250",
  "onboarding-scopes": "static-1.6355",
  "purchase-motions-api": "static-1.5668",
  "self-service-api": "static-1.10137",
  "signup-constants": "static-1.18639",
  "signup-ui-url-generator": "static-2.7931",
  "trials-service-types": "static-1.3794",
  "bender-build-tools": "static-1.3057",
  "chatspot-core": "static-1.20773",
  "ContentUtils": "static-1.67991",
  "copilot-toolkit": "static-1.10811",
  "sassPrefix": "static-1.153",
  "location-customization-utils-lib": "static-1.8875",
  "batch-promise": "static-1.1443",
  "react-dnd-compat": "static-1.4510",
  "react-immutable-render-mixin": "static-1.9",
  "deal-intel-utils": "static-1.1606",
  "storybook-react": "static-1.31",
  "framework-builder-read-service-client": "static-1.3919",
  "framework-data-schema-quick-fetch": "static-1.6672",
  "persist-promise": "static-1.3600",
  "apollo-link-hub-http": "static-2.4542",
  "hubspot-apollo-cache": "static-1.229",
  "reporting-client-types": "static-1.2427",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.68",
  "usage-tracker-public": "static-1.7039",
  "hubspotter-http-shared-msw-handlers": "static-1.9707",
  "usage-tracker-session-replay": "static-1.4914",
  "idb-keyval": "static-1.42",
  "magpie-types": "static-1.4945",
  "reactive-lib": "static-1.616",
  "simple-logging-lib": "static-1.2943",
  "calling-error-reporting": "static-1.31199",
  "shared-worker-versioning": "static-1.10930",
  "calling-usage-tracker": "static-1.6433",
  "voice-sms-access-library": "static-1.556",
  "conversations-skeleton-state": "static-1.7141",
  "immerable": "static-1.4045",
  "video-components-external": "static-1.10900",
  "video-data-lib": "static-1.34558",
  "directed-graph": "static-1.829",
  "event-emitter": "static-1.840",
  "fast-json-patch": "static-1.61",
  "getting-started-shared-tasks": "static-1.18168",
  "getting-started-shared-tasks-store": "static-1.17286",
  "onboarding-tours-utils": "static-1.467",
  "highcharts": "static-8.102",
  "trellis-story-utils": "static-1.4411",
  "FileManagerLib": "static-1.38898",
  "hub-http-contrib": "static-1.2935",
  "interframe": "static-3.4655",
  "tinymce-data": "static-1.40121",
  "ui-addon-sales-email": "static-1.5103",
  "codemirror": "static-5.93",
  "content-assistance-lib": "static-1.7589",
  "FileManagerCore": "static-1.38757",
  "layout-dnd-components": "static-1.12232",
  "layout-dnd-utils": "static-1.11207",
  "react-codemirror": "static-1.10515",
  "ui-addon-emoji-picker": "static-1.9779",
  "ui-brand-identity-lib": "static-1.14713",
  "NamespacedHubStyle": "static-2.8979",
  "ui-addon-opt": "static-4.8274",
  "sales-views-client-types": "static-1.4155",
  "superstore": "static-1.4661",
  "eligibility-engine-service-types": "static-1.3075",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4701",
  "content-icons-ui": "static-1.2196",
  "integrations-lib": "static-1.15739",
  "underscore": "static-1.8",
  "crm-record-cards-service-types": "static-1.3521",
  "amplitude-session-replay-browser": "static-1.58",
  "calling-orchestration-schema": "static-1.35333",
  "content-media-composition-data-lib": "static-1.11860",
  "content-media-compositions": "static-2.15867",
  "media-bridge-lib": "static-1.18733",
  "audio-components": "static-1.5752",
  "FileManagerImages": "static-1.36409",
  "video-components": "static-1.12903",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8588",
  "ui-coaching-tips": "static-1.28215",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29084",
  "ui-universal-auth": "static-1.8824",
  "urlinator": "static-1.4423",
  "video-embed": "static-1.35392",
  "ContentData": "static-1.68066",
  "layout-data-lib": "static-1.9532",
  "browser-eslint": "static-2.57",
  "emoji-mart": "static-3.4",
  "growth-onboarding-confetti": "static-1.2963",
  "flux-actions": "static-1.323",
  "integrations-error-boundary-lib": "static-1.13154",
  "integrations-tracking-lib": "static-1.5487",
  "native-integrations-shared-strings": "static-1.7678",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10265",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10039",
  "unified-auth": "static-1.338",
  "social-insights-client-types": "static-1.21731",
  "growth-onboarding-feedback-components": "static-1.6473",
  "unified-auth-core-lib": "static-1.619",
  "outpost": "static-1.4087",
  "advanced-menus-core": "static-1.14958",
  "advanced-menus-lib": "static-1.11922",
  "ExportDialog": "static-6.10282",
  "ui-memberships-settings-lib": "static-1.33724",
  "universal-page-editor-lib": "static-1.2898",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14957",
  "simple-menus-lib": "static-1.16474"
},
  depPathPrefixes: {
  "billing-portal-ui": "/billing-portal-ui/static-1.1048",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.455",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-test-utils": "/hs-test-utils/static-1.7903",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9709",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "react-dlb": "/react-dlb/static-1.76",
  "billing-portal-service-types": "/billing-portal-service-types/static-1.886",
  "data-fetching-client": "/data-fetching-client/static-1.9567",
  "foundations-assets": "/foundations-assets/static-1.4738",
  "foundations-components": "/foundations-components/static-1.7703",
  "foundations-theming": "/foundations-theming/static-1.4304",
  "framework-data-table": "/framework-data-table/static-2.11647",
  "hub-http": "/hub-http/static-1.6110",
  "HubStyleTokens": "/HubStyleTokens/static-2.11342",
  "I18n": "/I18n/static-7.1598",
  "metrics-js": "/metrics-js/static-1.9522",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "portals-platform-lib": "/portals-platform-lib/static-1.688",
  "quartz-config": "/quartz-config/static-1.634",
  "quartz-core": "/quartz-core/static-1.6075",
  "quick-fetch": "/quick-fetch/static-1.3826",
  "raven": "/raven/static-3.5808",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16546",
  "react-router-dom": "/react-router-dom/static-5.26",
  "redux": "/redux/static-4.16",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4535",
  "styled-components": "/styled-components/static-2.87",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8941",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9436",
  "UIComponents": "/UIComponents/static-3.8289",
  "usage-tracker": "/usage-tracker/static-1.7228",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5645",
  "usage-tracker-core": "/usage-tracker-core/static-1.7078",
  "customer-data-objects": "/customer-data-objects/static-1.7547",
  "customer-data-properties": "/customer-data-properties/static-1.51141",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7975",
  "sanitize-text": "/sanitize-text/static-1.8036",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.522",
  "property-translator": "/property-translator/static-1.5301",
  "smart-property-lib": "/smart-property-lib/static-1.6389",
  "commerce-products-lib": "/commerce-products-lib/static-1.9120",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11039",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10883",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48351",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17825",
  "purchase-motions-components": "/purchase-motions-components/static-1.5665",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.425",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "immutable": "/immutable/static-2.76",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3317",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3133",
  "quartz-webpack": "/quartz-webpack/static-1.3080",
  "HeadJS": "/HeadJS/static-2.732",
  "quartz": "/quartz/static-1.6856",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3014",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.3989",
  "webpack-env": "/webpack-env/static-1.54",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3972",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2020",
  "hs-story-utils": "/hs-story-utils/static-1.9321",
  "react-aria": "/react-aria/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5259",
  "react-virtualized": "/react-virtualized/static-2.97",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1502",
  "ui-fonts": "/ui-fonts/static-1.604",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2787",
  "foundations-theming-base": "/foundations-theming-base/static-1.3289",
  "stylex": "/stylex/static-1.30",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8646",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4053",
  "atom": "/atom/static-1.4962",
  "avatar-components": "/avatar-components/static-1.2385",
  "crm-links": "/crm-links/static-1.6167",
  "cssUtils": "/cssUtils/static-1.764",
  "customer-data-associations": "/customer-data-associations/static-1.7215",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12910",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13045",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9717",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1602",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6767",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7816",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5486",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4770",
  "HubStyle": "/HubStyle/static-2.11650",
  "icons": "/icons/static-2.637",
  "immer": "/immer/static-1.33",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "property-value-citations": "/property-value-citations/static-1.1755",
  "quartz-i18n": "/quartz-i18n/static-1.531",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8058",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7981",
  "reporting-data": "/reporting-data/static-1.66969",
  "sanitize": "/sanitize/static-1.4364",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "tanstack-virtual": "/tanstack-virtual/static-1.28",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4661",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.81",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5642",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4563",
  "jasmine": "/jasmine/static-4.4216",
  "jasmine-runner": "/jasmine-runner/static-1.6361",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.531",
  "quartz-head": "/quartz-head/static-1.521",
  "quartz-routing": "/quartz-routing/static-1.286",
  "quartz-test": "/quartz-test/static-1.531",
  "quartz-tracking": "/quartz-tracking/static-1.235",
  "usage-tracker-container": "/usage-tracker-container/static-1.7218",
  "csstype": "/csstype/static-1.50",
  "history": "/history/static-4.47",
  "chirp-fetch": "/chirp-fetch/static-1.1773",
  "magpie-lib": "/magpie-lib/static-1.5485",
  "navigation-messaging": "/navigation-messaging/static-1.6942",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3757",
  "autolinker": "/autolinker/static-3.11",
  "calling-global-api": "/calling-global-api/static-1.64063",
  "calling-internal-common": "/calling-internal-common/static-1.31193",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65445",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57739",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3708",
  "crm-message-bus": "/crm-message-bus/static-1.42658",
  "external-options-client-types": "/external-options-client-types/static-1.4069",
  "file-manager-components": "/file-manager-components/static-1.23258",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.29",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3500",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4134",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3600",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3876",
  "pulse": "/pulse/static-1.428",
  "tiered-pricing": "/tiered-pricing/static-1.996",
  "user-context": "/user-context/static-1.4991",
  "data-agent-kit": "/data-agent-kit/static-1.19",
  "data-token-picker": "/data-token-picker/static-1.16214",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9792",
  "fsm": "/fsm/static-1.3625",
  "policy-lib": "/policy-lib/static-1.6674",
  "react-colorpicker": "/react-colorpicker/static-2.10101",
  "react-tinymce": "/react-tinymce/static-1.54910",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9855",
  "rich-text-lib": "/rich-text-lib/static-1.19643",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54036",
  "tinymce-plugins": "/tinymce-plugins/static-1.57150",
  "tinymce-themes": "/tinymce-themes/static-1.56006",
  "commerce-permissions": "/commerce-permissions/static-1.657",
  "customer-data-tracking": "/customer-data-tracking/static-1.6775",
  "growth-payments-core": "/growth-payments-core/static-1.25018",
  "products-iframe-lib": "/products-iframe-lib/static-1.7608",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10091",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5186",
  "laboratory-lib": "/laboratory-lib/static-3.7051",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "salesImages": "/salesImages/static-1.522",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.728",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4393",
  "nav-client-types": "/nav-client-types/static-1.2250",
  "onboarding-scopes": "/onboarding-scopes/static-1.6355",
  "purchase-motions-api": "/purchase-motions-api/static-1.5668",
  "self-service-api": "/self-service-api/static-1.10137",
  "signup-constants": "/signup-constants/static-1.18639",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7931",
  "trials-service-types": "/trials-service-types/static-1.3794",
  "bender-build-tools": "/bender-build-tools/static-1.3057",
  "chatspot-core": "/chatspot-core/static-1.20773",
  "ContentUtils": "/ContentUtils/static-1.67991",
  "copilot-toolkit": "/copilot-toolkit/static-1.10811",
  "sassPrefix": "/sassPrefix/static-1.153",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8875",
  "batch-promise": "/batch-promise/static-1.1443",
  "react-dnd-compat": "/react-dnd-compat/static-1.4510",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "deal-intel-utils": "/deal-intel-utils/static-1.1606",
  "storybook-react": "/storybook-react/static-1.31",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3919",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6672",
  "persist-promise": "/persist-promise/static-1.3600",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4542",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.229",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.68",
  "usage-tracker-public": "/usage-tracker-public/static-1.7039",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9707",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4914",
  "idb-keyval": "/idb-keyval/static-1.42",
  "magpie-types": "/magpie-types/static-1.4945",
  "reactive-lib": "/reactive-lib/static-1.616",
  "simple-logging-lib": "/simple-logging-lib/static-1.2943",
  "calling-error-reporting": "/calling-error-reporting/static-1.31199",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10930",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6433",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.556",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7141",
  "immerable": "/immerable/static-1.4045",
  "video-components-external": "/video-components-external/static-1.10900",
  "video-data-lib": "/video-data-lib/static-1.34558",
  "directed-graph": "/directed-graph/static-1.829",
  "event-emitter": "/event-emitter/static-1.840",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18168",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17286",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.467",
  "highcharts": "/highcharts/static-8.102",
  "trellis-story-utils": "/trellis-story-utils/static-1.4411",
  "FileManagerLib": "/FileManagerLib/static-1.38898",
  "hub-http-contrib": "/hub-http-contrib/static-1.2935",
  "interframe": "/interframe/static-3.4655",
  "tinymce-data": "/tinymce-data/static-1.40121",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5103",
  "codemirror": "/codemirror/static-5.93",
  "content-assistance-lib": "/content-assistance-lib/static-1.7589",
  "FileManagerCore": "/FileManagerCore/static-1.38757",
  "layout-dnd-components": "/layout-dnd-components/static-1.12232",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11207",
  "react-codemirror": "/react-codemirror/static-1.10515",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9779",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14713",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8979",
  "ui-addon-opt": "/ui-addon-opt/static-4.8274",
  "sales-views-client-types": "/sales-views-client-types/static-1.4155",
  "superstore": "/superstore/static-1.4661",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3075",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4701",
  "content-icons-ui": "/content-icons-ui/static-1.2196",
  "integrations-lib": "/integrations-lib/static-1.15739",
  "underscore": "/underscore/static-1.8",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3521",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35333",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11860",
  "content-media-compositions": "/content-media-compositions/static-2.15867",
  "media-bridge-lib": "/media-bridge-lib/static-1.18733",
  "audio-components": "/audio-components/static-1.5752",
  "FileManagerImages": "/FileManagerImages/static-1.36409",
  "video-components": "/video-components/static-1.12903",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8588",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28215",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29084",
  "ui-universal-auth": "/ui-universal-auth/static-1.8824",
  "urlinator": "/urlinator/static-1.4423",
  "video-embed": "/video-embed/static-1.35392",
  "ContentData": "/ContentData/static-1.68066",
  "layout-data-lib": "/layout-data-lib/static-1.9532",
  "browser-eslint": "/browser-eslint/static-2.57",
  "emoji-mart": "/emoji-mart/static-3.4",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2963",
  "flux-actions": "/flux-actions/static-1.323",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13154",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5487",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7678",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10265",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10039",
  "unified-auth": "/unified-auth/static-1.338",
  "social-insights-client-types": "/social-insights-client-types/static-1.21731",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6473",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.619",
  "outpost": "/outpost/static-1.4087",
  "advanced-menus-core": "/advanced-menus-core/static-1.14958",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11922",
  "ExportDialog": "/ExportDialog/static-6.10282",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33724",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2898",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14957",
  "simple-menus-lib": "/simple-menus-lib/static-1.16474"
}
};
